import React from 'react'

import AddressHistory from 'app/match/applicationReportPDF/pages/Snug-pdf-2/AddressHistory'
import EmploymentDetails from 'app/match/applicationReportPDF/pages/Snug-pdf-2/EmploymentDetails'
import { resolveFormCapabilities } from 'app/utils/applications/formCapabilities'

const SnugPdf_2 = (props) => {
  const {
    employmentInfo = [],
    addressHistoryInfo = [],
    excludeRequestReasonForMoving = false,
    excludeArrangement = false,
    excludeOccupancy = false,
    excludeRent = false,
    isQLDForm,
    formCapabilities,
  } = props
  const resolvedFormCapabilities = resolveFormCapabilities(formCapabilities)
  return (
    <div>
      {resolvedFormCapabilities.hasEmploymentDetails && (
        <EmploymentDetails data={employmentInfo} isQLDForm={isQLDForm} />
      )}
      <AddressHistory
        data={addressHistoryInfo}
        excludeRequestReasonForMoving={excludeRequestReasonForMoving}
        excludeArrangement={excludeArrangement}
        excludeOccupancy={excludeOccupancy}
        excludeRent={excludeRent}
        isQLDForm22={isQLDForm}
      />
    </div>
  )
}

export default SnugPdf_2
